module.exports = "/templates/templatephrase.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/templatephrase.html
// module id = 478
// module chunks = 0